// The logo-over-a-Beta-pill hero of the unauthenticated shell (SignInPage,
// PendingApprovalPage). It is the Focus entry screens' hero (FocusFrame
// `heroLogo`, `focus/ui.tsx`), but here it occupies the top half of the screen
// and is centered within it — midway between the top edge and the
// vertically-centered card below.

import { LOGO_SRC } from "./logo";

// Inline on purpose: `.focus-hero` is unlayered CSS (`focus/focus.css`), which
// beats every Tailwind utility (those live in `@layer utilities`), so its
// `margin-top` and flow position can only be overridden at the element.
const HERO_POSITION = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "50vh",
  marginTop: 0,
  justifyContent: "center",
} as const;

/** The hero mark. The logo PNG is opaque (a cream tile, no alpha channel), so in
 *  dark mode it stays a light rounded app-icon tile — deliberately: no filter,
 *  no second asset. The pill reads the root `--accent` tokens and themes. */
export function HeroMark(): JSX.Element {
  return (
    <div className="focus-hero" style={HERO_POSITION}>
      <img className="focus-hero-logo" src={LOGO_SRC} alt="" aria-hidden />
      <span className="focus-hero-beta">Beta</span>
    </div>
  );
}
